import { message } from 'antd';
import appAction from '../redux/actions/appAction';

//High order method for tabular data acquisition
export function tableHoc(func) {
    let reqCount = 0;
    return function get(filter, sort, pagination, ...other) {
        return async (dispatch) => {
            dispatch(appAction.loading());
            try {
                const { res, actionType, ...otherProps } = await func(
                    filter,
                    sort,
                    pagination,
                    ...other
                );
                const { recordsTotal, records_total, data } = res;
                const total = records_total || recordsTotal;

                const { pageSize, current } = pagination;
                if (data.length === 0 && current > 1) { // causes an infinite recursive loop if next page has no results
                    reqCount++;
                    if (reqCount > 2) {
                        throw new Error('Failed to fetch required data');
                    }
                    return dispatch(
                        get(filter, sort, {
                            ...pagination,
                            total: total,
                            current: Math.ceil(total / pageSize),
                        })
                    );
                }
                dispatch({
                    type: actionType,
                    ...otherProps,
                    data: {
                        data: data,
                        filter,
                        sort,
                        pagination: {
                            ...pagination,
                            total: total,
                        },
                    },
                });
                return res;
            } catch (e) {
                console.log(e);
                if (e.message) {
                    if (e.message.includes('login again')) {
                        message.error(e.message);
                    }
                    //notification.error({
                    //    message: 'loading fail',
                    //    description:
                    //        'An error occurred while requesting data.',
                    //});
                    throw e;
                }
            } finally {
                reqCount = 0;
            }
            dispatch(appAction.loaded());
        };
    };
}
